/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-06-28 15:31:39
 * @LastEditTime: 2019-07-24 14:52:17
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  普通仓库供给管理接口Url
const websiteSupplyUrl = '/website/storage/supply'

/* 获取地址接口 */
const getAreaUrl = `/sys/sysArea/find`

/* 查询字典接口 */
const getDictUrl = `/sys/dict/getDict`

// 获取字典接口
export function getDict(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getDictUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getListByType',
        type: param,
        hasAll: 'no'
      }, {}))
    }
  })
}

// 分页查询普通仓库列表
export function findPageSupply(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteSupplyUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageSupply'
      }, param))
    }
  })
}
// 获取地址接口
export function getArea(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getAreaUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findTreeData'
      }, param))
    }
  })
}

// 删除普通仓库供给列表
export function supplyRemove(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteSupplyUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'supplyRemove'
      }, param))
    }
  })
}

// 删除普通仓库供给列表
export function supplyEdit(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteSupplyUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'supplyEdit'
      }, param))
    }
  })
}

// 批量删除普通仓库供给列表
export function delBatch(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteSupplyUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'delBatch'
      }, param))
    }
  })
}

// 批量发布普通仓库供给列表
export function issueBatch(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteSupplyUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'issueBatch'
      }, param))
    }
  })
}

// 查询仓库供给详情信息
export function findSupplyById(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteSupplyUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'supplyRemove'
      }, param))
    }
  })
}
